import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Card, CardContent, Button, CircularProgress, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { Add, Business, Event, School } from '@mui/icons-material';
import axios from 'axios';

const Scholarships = () => {
  const navigate = useNavigate();
  const [scholarships, setScholarships] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchScholarships = async () => {
      try {
        const response = await axios.get('https://kidsm.vercel.app/api/schools/scholarships');
        setScholarships(response.data);
      } catch (error) {
        console.error('Error fetching scholarships:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchScholarships();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Button
          variant="contained"
          sx={{
            mb: 4,
            bgcolor: '#6200ee',
            borderRadius: 2,
            py: 1.5,
            px: 3,
            textTransform: 'none',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            '&:hover': { bgcolor: '#3700b3' },
          }}
          startIcon={<Add />}
          onClick={() => navigate('/publish-scholarship')}
        >
          Publish Scholarship
        </Button>

        {scholarships.length === 0 ? (
          <Typography sx={{ textAlign: 'center', color: '#666', mt: 8, fontSize: '1rem' }}>
            No scholarships published yet
          </Typography>
        ) : (
          scholarships.map(scholarship => (
            <Card
              key={scholarship._id}
              sx={{
                mb: 2,
                bgcolor: '#fff',
                borderRadius: 2,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/scholarship-details', { state: { scholarship } })}
            >
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 1 }}>
                  {scholarship.title}
                </Typography>
                <Grid container alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                  <Grid item>
                    <Business sx={{ color: '#6200ee', fontSize: 16 }} />
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontSize: '0.875rem', color: '#666' }}>
                      {scholarship.hostOrganization}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                  <Grid item>
                    <Event sx={{ color: '#6200ee', fontSize: 16 }} />
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontSize: '0.875rem', color: '#666' }}>
                      Deadline: {new Date(scholarship.deadline).toLocaleDateString()}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <School sx={{ color: '#6200ee', fontSize: 16 }} />
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontSize: '0.875rem', color: '#666' }}>
                      {scholarship.level} • {scholarship.type}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))
        )}
      </motion.div>
    </Container>
  );
};

export default Scholarships;